import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';

import { store } from './store';

import usersApiSlice from '@/api/endpoints/users';

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export interface RouterContext {
  usersApi: typeof usersApiSlice;
  store: typeof store;
}

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  context: { usersApi: usersApiSlice, store },
});
